/**
 * @generated SignedSource<<18dce322dd03b3f9a733c212a5ba5249>>
 * @relayHash 412492ff6ce3f5231d4cac5c4a6efa40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c2693717915c7761395ebad21c4ea1fe681e2e2d81b75ba17d4f651a4fbd9f2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalAccessManagementPageQuery } from './GlobalAccessManagementPageQuery.graphql';

const node: PreloadableConcreteRequest<GlobalAccessManagementPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1c2693717915c7761395ebad21c4ea1fe681e2e2d81b75ba17d4f651a4fbd9f2",
    "metadata": {},
    "name": "GlobalAccessManagementPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
